import { Card } from 'antd'
import { type FC, type ReactNode } from 'react'

const FormCard: FC<{ children: ReactNode }> = ({ children }) => {
  return <Card
    variant='outlined'
    style={{
      width: 350, minHeight: 370
    }}>
    {children}
  </Card>
}

export default FormCard
